import {itaiji} from "./itaiji";
import isEmpty from "lodash/isEmpty";

const kanjiMapping = {
    'Ⅰ': 'I',
    'Ⅱ': 'II',
    'Ⅲ': 'III',
    'Ⅳ': 'IV',
    'Ⅴ': 'V',
    'Ⅵ': 'VI',
    'Ⅶ': 'VI',
};
{
    for (const [key, values] of Object.entries(itaiji)) {
        values.forEach((v) => kanjiMapping[v] = key);
    }
}
const normalizeExp = new RegExp(`[${Object.keys(kanjiMapping).join("")}]`, 'g');

export const normalizeKanji = (str) =>
    str?.replace(normalizeExp, char => kanjiMapping[char] || char);

export function queryStringToHash() {
  const params = {};

  new URLSearchParams(location.search).forEach((value, key) => {
    const decodedKey = decodeURIComponent(key);
    const decodedValue = decodeURIComponent(value);

    if (decodedKey.endsWith("[]")) {
      const replacedKey =  decodedKey.replace("[]", "");
      params[replacedKey] || (params[replacedKey] = []);
      params[replacedKey].push(decodedValue);
    } else {
      params[decodedKey] = decodedValue;
    }
  });

  return params;
}

export function hashToQueryString(hash) {
    return Object.keys(hash).sort().filter(key => !isEmpty(key) && key !== 'page' && hash[key] !== undefined && hash[key] !== '').map((key) => {
      if (Array.isArray(hash[key])) {
        return hash[key]
          .map(val => [`${key}[]`, val || ''].map(encodeURIComponent).join('='))
          .join('&');
      } else {
        return [key, hash[key]].map(encodeURIComponent).join('=');
      }
    }).join('&');
}

export function updateQueryString(params) {
    let url = location.pathname;
    if (!isEmpty(url)) {
        url += '?' + hashToQueryString({...queryStringToHash(), ...params});
    }
    showLoader();
    location.href = url;
}

export const csrfParam = () => document.querySelector('meta[name="csrf-param"]').getAttribute('content');
export const csrfToken = () => document.querySelector('meta[name="csrf-token"]').getAttribute('content');

export const csrfHeader = () => ({'X-CSRF-Token': csrfToken()});

export const showLoader = () => {
    const loading = document.querySelector('.loading');;
    loading.classList.add('active');
}
